const { hardcore } = window.o_util ?? {};
const { evalScript, executeInlineScripts } = hardcore ?? {};
export {
  evalScript,
  executeInlineScripts,
  hardcore
};
/*                                 */
